import {Serializer} from "../interfaces/serializer";
import {BehaviorSubject} from "rxjs";
import {MetricComponentObjects} from "./metric-component-object";
import {DimensionComponentObjects} from "./dimension-component-object";
import {CustomImportMappingItemComponentObject} from "./custom-import-mapping-item-component-object";

export interface DatasetUsageCustomConfiguration {
  import_type: string;
  import_method: string;
  date_mode: string;
  date_parameters: any;
  mapping: any[];
  currency: string;
  parameters: string;
}

export class DatasetUsageCustomConfigurationComponentObject {
  public readonly payload: Serializer<DatasetUsageCustomConfiguration>;

  public readonly import_method$: BehaviorSubject<string> = new BehaviorSubject(null);
  public readonly import_type$: BehaviorSubject<string> = new BehaviorSubject(null);
  public readonly date_mode$: BehaviorSubject<string> = new BehaviorSubject(null);
  public readonly dimensions$: BehaviorSubject<CustomImportMappingItemComponentObject[]> = new BehaviorSubject([]);
  public readonly nbDimensions$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public readonly metrics$: BehaviorSubject<CustomImportMappingItemComponentObject[]> = new BehaviorSubject([]);
  public readonly nbMetrics$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public readonly currency$: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor(payload: Serializer<DatasetUsageCustomConfiguration>) {
    this.payload = payload;

    this.import_method$.next(payload.attributes.import_method);
    this.import_type$.next(payload.attributes.import_type);
    this.date_mode$.next(payload.attributes.date_mode);

    if (payload.attributes.mapping) {
      this.dimensions$.next(
        payload.attributes.mapping
          .filter((item: any): boolean => item['type'] === 'DataSourceDimension')
          .map((item: any) => new CustomImportMappingItemComponentObject(item))
      );

      switch (payload.attributes.date_mode) {
        case 'date_column':
          this.dimensions$.value.unshift(new CustomImportMappingItemComponentObject({ ext_name: payload.attributes.date_parameters['column'], type: 'DataSourceDimension', ext_format: payload.attributes.date_parameters['format'], date: true }));
          break;
        case 'file_name':
          // ???
          break;
      }

      this.nbDimensions$.next(this.dimensions$.value.length);

      this.metrics$.next(
        payload.attributes.mapping
          .filter((item: any): boolean => item['type'] === 'DataSourceMetric')
          .map((item: any) => new CustomImportMappingItemComponentObject(item))
      );

      this.nbMetrics$.next(this.metrics$.value.length);

      this.currency$.next(payload.attributes.currency);
    }
  }

  public initDimensions(generalDimensions: DimensionComponentObjects, dimensions: DimensionComponentObjects): void {
    this.dimensions$.value.forEach((dimension: CustomImportMappingItemComponentObject): void => dimension.initDimensions(generalDimensions, dimensions));
  }

  public initMetrics(metrics: MetricComponentObjects): void {
    this.metrics$.value.forEach((metric: CustomImportMappingItemComponentObject): void => metric.initMetrics(metrics));
  }

  private getDateFormat(format: string): string {
    switch (format) {
      case '%Y-%m-%d':
        return 'yyyy-mm-dd';
      case '%d-%m-%Y':
        return 'dd-mm-yyyy';
      case '%m-%d-%Y':
        return 'mm-dd-yyyy';
      case '%Y/%m/%d':
        return 'yyyy/mm/dd';
      case '%d/%m/%Y':
        return 'dd/mm/yyyy';
      case '%m/%d/%Y':
        return 'mm/dd/yyyy';
    }
  }

}
